import { errorToReason } from '../error-to-reason';
export let SwitcherLoadErrorReason = /*#__PURE__*/function (SwitcherLoadErrorReason) {
  SwitcherLoadErrorReason["AVAILABLE_PRODUCTS"] = "availableProducts";
  SwitcherLoadErrorReason["PRODUCT_CONFIGURATION"] = "productConfiguration";
  return SwitcherLoadErrorReason;
}({});
export class SwitcherLoadError extends Error {
  constructor(errorReason, resultError) {
    super();
    this.errorReason = errorReason;
    this.resultError = resultError;
  }
  reason() {
    const potentialResultError = this.resultError;
    return {
      ...errorToReason(potentialResultError.error ? potentialResultError.error : this.resultError),
      source: this.errorReason
    };
  }
}